export class NSCookiesHeader 
{
}